import React from 'react'

export default function VipIncident() {
  return (
    <div>VipIncident</div>
  )
}
